import { TripCartPrice } from 'src/common/types';
import { apiRequest } from 'src/common/utils/apiFetch';
import captureException from 'src/common/utils/captureException';

export type PriceParams = {
  date?: string;
  duration: string;
  guests: string;
  captainOption: string;
  /**
   * It should be currency symbol. For example: `USD`
   */
  currency?: string;

};
const calculatePrices = async (
  boatId: string,
  params: PriceParams,
): Promise<TripCartPrice> => {
  const {
    date, duration, guests, captainOption, currency,
  } = params;
  const searchParams = new URLSearchParams({
    guests,
    captain_option: captainOption,
    duration,
  });

  if (currency) {
    searchParams.append('currency', currency);
  }

  if (date) {
    searchParams.append('start_date', date);
  }

  const url = `/api/v4/boats/${boatId}/calculate_price/?${searchParams.toString()}`;
  try {
    const response = await apiRequest(url);
    if (response.status === 200) {
      const priceData: TripCartPrice = await response.json();
      return priceData;
    }

    return {
      price_sections: [],
    };
  } catch (error) {
    captureException(error);
    return {
      price_sections: [],
    };
  }
};

export default calculatePrices;
